import { z } from "zod";

export const SubmitFeedbackSchema = z.object({
  feedback: z.string().trim().min(1),
  score: z.number(),
});

export type SubmitFeedbackValues = z.infer<typeof SubmitFeedbackSchema>;

export const defaultSubmitFeedbackValues: SubmitFeedbackValues = {
  feedback: "",
  score: 1,
};
